export class ClientResponse{constructor(value,statusCode){this.value=value;this.statusCode=statusCode;}}